import { createSelector } from '@ngrx/store';

import * as fromReducers from '../reducers';

export const getOpusJobsDetailsState = createSelector(fromReducers.getOpusJobsState, (state: fromReducers.OpusJobsState) => state.details);

export const getOpusJobs = createSelector(getOpusJobsDetailsState, (state: fromReducers.OpusJobDetailsState) => state.opusJobs);
